import { render, staticRenderFns } from "./location-assign.vue?vue&type=template&id=76e8c786"
import script from "./location-assign.vue?vue&type=script&lang=js"
export * from "./location-assign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports